import type { GetProp, UploadProps } from "antd";
import APIRequest from "../API";
import * as APIPath from "../API/path";
import * as InterFace from "./interface.config";
import axios from "axios";
import { SubscribeToDetails } from "./interface.config";
import { ALLOWED_PLANS } from "../Utils/pricing";
import { clearLocalCreatorPushSubscription } from "../Utils/pushNotificationLocal";
type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];

export const getSessionToken: () => string = () =>
  localStorage.getItem("auth-access") ?? "";

export const updateToken = (access: string, refresh: string) => {
  localStorage.setItem("auth-access", access);
  localStorage.setItem("refresh-access", refresh);
};

export const logout = () => {
  void clearLocalCreatorPushSubscription();
  localStorage.clear();
  window.location.href = "/";
};

export const getBase64 = (file: FileType): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

export const generatePassword = (length: number) => {
  const lowercaseChars = "abcdefghijklmnopqrstuvwxyz";
  const uppercaseChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const numbers = "0123456789";
  const specialChars = "!@#$%^&*()_+{}[]<>?";

  let password =
    lowercaseChars[Math.floor(Math.random() * lowercaseChars.length)];
  password += uppercaseChars[Math.floor(Math.random() * uppercaseChars.length)];
  password += numbers[Math.floor(Math.random() * numbers.length)];

  const remainingLength = length - 3;
  const charset = lowercaseChars + uppercaseChars + numbers + specialChars;
  for (let i = 0; i < remainingLength; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    password += charset[randomIndex];
  }

  password = password
    .split("")
    .sort(() => Math.random() - 0.5)
    .join("");

  return password;
};

export const isCreatorRole = (role: string | null | undefined) => {
  return role === process.env.REACT_APP_CREATOR_ROLE_ID;
};

export const scrollToBottom = (element_id: string) => {
  const element = document.getElementById(element_id) as HTMLDivElement;
  if (!element) return;
  element.scrollTop = element.scrollHeight;
  element.scrollIntoView({ behavior: "smooth" });
};

export const postAndCommentLinkHandler = async ({
  post,
  comment,
  likedBy,
}: InterFace.LikeInteface) => {
  try {
    let payload: InterFace.LikeInteface = {
      likedBy,
    };
    if (post) payload.post = post;
    if (comment) payload.comment = comment;

    const resp: any = await APIRequest(APIPath.linkHandler, payload);
    return resp.data;
  } catch (error) {
    return error;
  }
};

export const isFileVideo = (fileURL: string) => {
  if (!fileURL) return false;

  if (fileURL.startsWith("data:")) {
    return fileURL.startsWith("data:video/");
  }

  const ext = "." + fileURL.split(".").pop()?.toLowerCase();
  const videoExtensions = [
    ".mp4",
    ".avi",
    ".mkv",
    ".mov",
    ".wmv",
    ".flv",
    ".webm",
    ".ogg",
  ];

  return videoExtensions.includes(ext);
};

export const googleAccountDetails = async (token: string) => {
  try {
    const { data } = await axios.get(
      `https://www.googleapis.com/oauth2/v3/userinfo?access_token=${token}`
    );
    return data;
  } catch (error) {
    return null;
  }
};

export const loadScript = (src: string) => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
};

export const DEFAULT_PRICING = ALLOWED_PLANS[0].setValue;

export const FANXOBILLPHONENUMBER = "9999999900";

export const DEFAULT_SUBSCRIPTION_CONTACT_NUMBER = "+919999999900";

export const getCheckoutContactNumber = (
  user?: Partial<InterFace.UserDetails> & Record<string, any>
) => {
  const contactCandidates = [
    user?.contact,
    user?.phone,
    user?.phoneNumber,
    user?.mobile,
    user?.mobileNumber,
  ];

  const resolvedContact = contactCandidates.find(
    (value) => typeof value === "string" && value.trim().length > 0
  );

  return resolvedContact || DEFAULT_SUBSCRIPTION_CONTACT_NUMBER;
};

export const getToken = () => localStorage.getItem("auth-access") ?? null;

export const checkIsSubscribe = (
  creatorId: string,
  loggedInUserSubscribeArray:
    | (SubscribeToDetails | string | { toString?: () => string })[]
    | undefined
): boolean => {
  if (
    !loggedInUserSubscribeArray ||
    !Array.isArray(loggedInUserSubscribeArray)
  ) {
    return false;
  }

  const normalizedCreatorId = creatorId?.toString();

  return loggedInUserSubscribeArray.some((subscription) => {
    if (!subscription) return false;

    if (typeof subscription === "string") {
      return subscription === normalizedCreatorId;
    }

    const subscribedCreatorId =
      (subscription as SubscribeToDetails)._id ||
      (subscription as SubscribeToDetails).id ||
      subscription.toString?.();

    return subscribedCreatorId?.toString() === normalizedCreatorId;
  });
};
